<template>
  <div class="chat-window">
    <div class="chat-window-container">
      <div class="chat-window-header" @click="$emit('dismiss')">
        <span>{{recipient.first_name }}</span>
        <h-icon color="black">close</h-icon>
      </div >
      <div class="chat-window-messages-container" :class="{finished: finished}" @scroll="onScroll">
        <v-progress-circular v-if="loading" :value="40" class="loading" indeterminate color="orange"></v-progress-circular>
        <div v-for="message in messages" :key="message.id">
          <message :message="message" />
        </div>
      </div>
      <form class="window-input" @submit.prevent="sendMessage">
        <textarea type="text" placeholder="Send a message"  v-model="messageContent"></textarea>
        <button type="submit" flat>
          send
        </button>
      </form>
    </div>
    <!--<p @keydown.enter="sendMessage" id="message-input" contenteditable="true" class="message-input"></p>-->
  </div>
</template>
<script>
/* TODO: this is exactly the same as roomMessages.js (besides jquery look up for scroll)
There is a bug by re-using the roomMessages.js it uses the messageRoom template.
Figure out how to remove this duplication */
import message from "./message";
import User from "@/services/api/authUser";
import moment from "moment";
import Rooms from "@/services/messaging/rooms";
import dataStore from "@/services/api/store";
import roomsSeenHub from "@/services/hubs/roomsSeen";
import Nazgul from "@/services/nazgul";

const chatContainer = ".chat-window-messages-container";

export default {
  props: ["room", "recipient", "store", "notify"],
  components: { message },
  data() {
    return {
      messages: [],
      messageContent: "",
      loading: false,
      finished: false,
      atTop: false
    };
  },
  created() {
    this._store = this.store || "CoachMessagingRooms";
    this.setLastSeen();
    this.lastScroll = 0;
    this.messagingRoom = Rooms.getRoom(this.room.id);
    this.loading = true;
    this.messagingRoom.init().then(messages => {
      this.messages = [...messages];
      setTimeout(() => {
        this.scrollBottom();
      });
      this.loading = false;
    });
    this.subscription = this.messagingRoom.messagesSub.subscribe(message => {
      this.messages.push(message);
      setTimeout(() => this.scrollBottom());
      this.setLastSeen();
    });
  },
  methods: {
    setLastSeen() {
      dataStore.update(this._store, this.room.id, {
        last_seen: moment().format()
      });
      roomsSeenHub.update(this.room.id);
    },
    sendMessage() {
      if (!this.messageContent) {
        return;
      }
      Nazgul.report("message_sent");

      let message = {
        sender_id: User.id,
        room_id: this.room.id,
        sender: {
          image: User.image,
          id: User.id,
          first_name: User.first_name,
          last_name: User.last_name,
          email: User.email
        },
        created_at: moment(),
        payload: {
          message: this.messageContent
        }
      };
      this.messagingRoom.sendMessage(message);
      this.messageContent = "";
    },
    onScroll() {
      let messageContainer = this.$el.querySelector(chatContainer);
      let currentScroll = messageContainer.scrollTop;
      if (
        !this.loading &&
        !this.finished &&
        currentScroll < this.lastScroll &&
        messageContainer.scrollTop < 50
      ) {
        this.loading = true;
        this.messagingRoom
          .loadMoreMessages()
          .then(messages => {
            this.finished = this.messagingRoom.finished;
            this.messages = messages.concat(this.messages);
            // give a little offset so the user has to scroll up to get more
            messageContainer.scrollTop = 50;
          })
          .then(() => (this.loading = false));
      }
      this.lastScroll = currentScroll;
    },
    scrollBottom() {
      let messageContainer = this.$el.querySelector(chatContainer);
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  },
  beforeDestroy() {
    this.setLastSeen();
  },
  destroyed() {
    this.subscription.unsubscribe();
  }
};
</script>

<style lang="less" scoped>
.chat-window {
  background-color: #e4e4e4;
  bottom: 0;
  height: 60vh;
  left: 20px;
  position: fixed;
  width: 400px;
  z-index: 100;

  .fade-enter {
    transition: max-height 5s;
  }

  @media (max-width: 740px) {
    width: 100vw;
    left: 0px;
    height: 100vh;
  }

  .loading {
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100%;
  }

  .chat-window-container {
    /*position: relative;*/
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: height 5s;

    .chat-window-header {
      align-content: center;
      align-items: center;
      background-image: linear-gradient(to right, #26b8fe, #34cea9);
      color: white;
      display: flex;
      height: 50px;
      justify-content: space-between;
      padding: 5px 10px;
      width: 100%;
      @media (max-width: 700px) {
        margin-bottom: 15px;
        position: fixed;
        top: 0;
        z-index: 1;
      }
    }
  }

  .window-input {
    width: 100%;
    /*border-style: none;*/
    // position: relative;
    margin: 0;
    align-content: flex-end;
    height: 150px;
    display: flex;
    background-image: linear-gradient(to right, #26b8fe, #34cea9);
    line-height: 25px;
    z-index: 1000;
    textarea,
    textarea:focus {
      padding: 10px;
      width: 100%;
      outline: none;
      flex: 3;
      resize: none;
      z-index: 1;
      background-color: white;
      margin: .5em;
    }
    button,
    button:focus {
      flex: 1;
      color: white;
      outline: none;
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
    }
  }
  .chat-window-messages-container {
    padding: 10px;
    overflow: scroll;
    height: 80%;
    padding-top: 60px;
    &.finished {
      @media (max-width: 740px) {
        padding-top: 100px !important;
      }
    }
  }
}
</style>
